import { cn } from '@/lib/utils'
import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'
import * as React from 'react'

const logoVariants = cva('w-auto object-contain transition-all', {
  variants: {
    size: {
      xs: 'h-3 sm:h-3.5 md:h-4 lg:h-5',
      sm: 'h-4 sm:h-5 md:h-6 lg:h-7',
      md: 'h-5 sm:h-6 md:h-8 lg:h-9',
      lg: 'h-7 sm:h-8 md:h-10 lg:h-12',
      xl: 'h-9 sm:h-10 md:h-12 lg:h-14',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

interface LogoProps
  extends React.ComponentProps<'img'>,
  VariantProps<typeof logoVariants> {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

function Logo({ className, size = 'md', alt = 'Logo', ...props }: LogoProps) {
  return (
    <img
      src="/full-logo.webp"
      alt={alt}
      width={1920}
      height={245}
      loading="lazy"
      decoding="async"
      className={cn(logoVariants({ size, className }))}
      {...props}
    />
  )
}

export { Logo, logoVariants }
